import React from 'react';
import { useTranslation } from 'react-i18next';
import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <div className="app__bg section__padding" id="about">
      <div className="app__container">
        <div className="section__title">
          <h1 className="headtext__cormorant">{t('greeting')}</h1>
          <div className="section__title-accent" />
        </div>

        <div className="app__aboutus-content_about">
          <div className="app__aboutus-image">
            <img src={images.gallery02} alt="MaiThai" loading="lazy" />
          </div>
          <p className="app__aboutus-content_about_text">{t('about_1')}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
